import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "nav-wrapper" };
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = { class: "nav-menu" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "nav-icon" };
const _hoisted_6 = { class: "nav-label" };
const _hoisted_7 = {
    key: 1,
    class: "nav-parent"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "nav-icon" };
const _hoisted_10 = { class: "nav-label" };
const _hoisted_11 = {
    key: 0,
    class: "nav-children"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = { class: "nav-icon" };
const _hoisted_14 = { class: "nav-label" };
import { ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdminSideNav',
    props: {
        activeItem: { default: 'dashboard' }
    },
    emits: ["item-selected"],
    setup(__props, { emit: __emit }) {
        const route = useRoute();
        const router = useRouter();
        const props = __props;
        const emit = __emit;
        const isExpanded = ref(false);
        const expandedParents = ref([]);
        const menuItems = [
            {
                id: 'dashboard',
                label: 'Dashboard',
                icon: '📊',
                route: '/admin'
            },
            {
                id: 'business',
                label: 'Business',
                icon: '🏢',
                children: [
                    {
                        id: 'employers',
                        label: 'Employers',
                        icon: '🏭',
                        route: '/admin/employers'
                    },
                    {
                        id: 'merchants',
                        label: 'Merchants',
                        icon: '🏪',
                        route: '/admin/merchants'
                    },
                    {
                        id: 'transaction-classifications',
                        label: 'Transaction Classifications',
                        icon: '🏷️',
                        route: '/admin/transaction-classifications'
                    },
                    {
                        id: 'lists',
                        label: 'Lists',
                        icon: '📋',
                        route: '/admin/lists'
                    },
                    {
                        id: 'customers',
                        label: 'Customers',
                        icon: '👤',
                        route: '/admin/customers'
                    },
                    {
                        id: 'customer-uploads',
                        label: 'Customer Uploads',
                        icon: '📤',
                        route: '/admin/customer-uploads'
                    },
                    {
                        id: 'ai-chat-settings',
                        label: 'AI Chat Settings',
                        icon: '🤖',
                        route: '/admin/ai-chat-settings'
                    },
                    {
                        id: 'ai-chat-messages',
                        label: 'AI Chat Messages',
                        icon: '💬',
                        route: '/admin/ai-chat-messages'
                    },
                    {
                        id: 'referrals',
                        label: 'Referrals',
                        icon: '🎁',
                        route: '/admin/referrals'
                    }
                ]
            },
            {
                id: 'content',
                label: 'Content',
                icon: '📝',
                children: [
                    // {
                    // 	id: 'cms',
                    // 	label: 'CMS',
                    // 	icon: '📄'
                    // },
                    {
                        id: 'cdn',
                        label: 'CDN',
                        icon: '🌐',
                        route: '/admin/cdn-upload'
                    },
                    {
                        id: 'factoids',
                        label: 'Factoids',
                        icon: '📚',
                        route: '/admin/factoids'
                    },
                    {
                        id: 'guides',
                        label: 'Guides',
                        icon: '🗺️',
                        route: '/admin/guides'
                    },
                    {
                        id: 'quizzes',
                        label: 'Quizzes',
                        icon: '🧠',
                        route: '/admin/quizzes'
                    },
                    {
                        id: 'walkthroughs',
                        label: 'Walkthroughs',
                        icon: '🎬',
                        route: '/admin/walkthroughs'
                    },
                    {
                        id: 'vouchers',
                        label: 'Vouchers',
                        icon: '🎟️',
                        route: '/admin/vouchers'
                    },
                    {
                        id: 'categories',
                        label: 'Categories',
                        icon: '🏷️',
                        route: '/admin/categories'
                    },
                    {
                        id: 'faqs',
                        label: 'FAQs',
                        icon: '❓',
                        route: '/admin/faqs'
                    },
                    {
                        id: 'policy-sections',
                        label: 'Policy Sections',
                        icon: '📋',
                        route: '/admin/policy-sections'
                    },
                    {
                        id: 'brand-logo-overrides',
                        label: 'Brand Logo Overrides',
                        icon: '🖼️',
                        route: '/admin/brand-logo-overrides'
                    }
                ]
            },
            {
                id: 'system',
                label: 'System',
                icon: '⚙️',
                children: [
                    {
                        id: 'cache',
                        label: 'Cache',
                        icon: '💾',
                        route: '/admin/cache'
                    },
                    {
                        id: 'git-history',
                        label: 'Git History',
                        icon: '📜',
                        route: '/admin/git-history'
                    }
                ]
            }
        ];
        const currentActiveItem = computed(() => {
            const currentPath = route.path;
            // Check top-level items
            for (const item of menuItems) {
                if (item.route && item.route === currentPath) {
                    return item.id;
                }
                // Check children
                if (item.children) {
                    for (const child of item.children) {
                        if (child.route && child.route === currentPath) {
                            return child.id;
                        }
                    }
                }
            }
            return props.activeItem;
        });
        watch(currentActiveItem, (newActiveItem) => {
            // Auto-expand parent if active item is a child
            for (const item of menuItems) {
                if (item.children) {
                    const isChildActive = item.children.some((child) => child.id === newActiveItem);
                    if (isChildActive && !expandedParents.value.includes(item.id)) {
                        expandedParents.value.push(item.id);
                    }
                }
            }
        });
        function toggleNav() {
            isExpanded.value = !isExpanded.value;
        }
        function toggleParent(parentId) {
            const index = expandedParents.value.indexOf(parentId);
            if (index > -1) {
                expandedParents.value.splice(index, 1);
            }
            else {
                expandedParents.value.push(parentId);
            }
        }
        function selectItem(itemId) {
            // Find the item in menuItems (including children)
            let item = null;
            for (const menuItem of menuItems) {
                if (menuItem.id === itemId) {
                    item = menuItem;
                    break;
                }
                if (menuItem.children) {
                    const child = menuItem.children.find((c) => c.id === itemId);
                    if (child) {
                        item = child;
                        break;
                    }
                }
            }
            // Navigate to route if item has one, otherwise emit event
            if (item && item.route) {
                router.push(item.route);
            }
            else {
                emit('item-selected', itemId);
            }
            // Auto-close on mobile after selection
            if (window.innerWidth < 768) {
                isExpanded.value = false;
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    class: "hamburger-btn",
                    onClick: toggleNav,
                    "aria-label": isExpanded.value ? 'Close menu' : 'Open menu'
                }, [
                    _createElementVNode("span", {
                        class: _normalizeClass(["hamburger-icon", { active: isExpanded.value }])
                    }, _cache[0] || (_cache[0] = [
                        _createElementVNode("span", null, null, -1),
                        _createElementVNode("span", null, null, -1),
                        _createElementVNode("span", null, null, -1)
                    ]), 2)
                ], 8, _hoisted_2),
                _createElementVNode("nav", {
                    class: _normalizeClass(["admin-side-nav", { expanded: isExpanded.value }])
                }, [
                    _createElementVNode("div", { class: "nav-header" }, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-title" }, [
                            _createElementVNode("h2", null, "Admin")
                        ], -1)),
                        _createElementVNode("button", {
                            class: "close-btn",
                            onClick: toggleNav,
                            "aria-label": "Close menu"
                        }, "✕")
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                                key: item.id
                            }, [
                                (!item.children)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["nav-item", { active: currentActiveItem.value === item.id }]),
                                        onClick: ($event) => (selectItem(item.id))
                                    }, [
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(item.icon), 1),
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1)
                                    ], 10, _hoisted_4))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["nav-item parent-item", { active: expandedParents.value.includes(item.id) }]),
                                            onClick: ($event) => (toggleParent(item.id))
                                        }, [
                                            _createElementVNode("span", _hoisted_9, _toDisplayString(item.icon), 1),
                                            _createElementVNode("span", _hoisted_10, _toDisplayString(item.label), 1),
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["expand-icon", { rotated: expandedParents.value.includes(item.id) }])
                                            }, "›", 2)
                                        ], 10, _hoisted_8),
                                        _createVNode(_Transition, { name: "expand" }, {
                                            default: _withCtx(() => [
                                                (expandedParents.value.includes(item.id))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: child.id,
                                                                class: _normalizeClass(["nav-item child-item", { active: currentActiveItem.value === child.id }]),
                                                                onClick: ($event) => (selectItem(child.id))
                                                            }, [
                                                                _createElementVNode("span", _hoisted_13, _toDisplayString(child.icon), 1),
                                                                _createElementVNode("span", _hoisted_14, _toDisplayString(child.label), 1)
                                                            ], 10, _hoisted_12));
                                                        }), 128))
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                        }, 1024)
                                    ]))
                            ], 64));
                        }), 64))
                    ])
                ], 2),
                (isExpanded.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "nav-overlay",
                        onClick: toggleNav
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
